import FlexCell from "./FlexCell";

export default FlexCell;
